import { useState } from "react";
import { reloadToNewVersion, useNewVersion } from "./offline.ts";
import { Button } from "./souvenir.ts";

// A new version of Tripmo is ready: the page keeps running the one it started with until Reload. In
// the live banner's place and look; `floating` where the page has no banner of its own (Your trips,
// the profile).
export function NewVersion({ floating = false }: { floating?: boolean }) {
  const ready = useNewVersion();
  const [loading, setLoading] = useState(false);
  if (!ready) return null;
  return (
    <div className={floating ? "tm-live tm-new-version tm-live-floating" : "tm-live tm-new-version"} role="status">
      <span className="callout">A new version of Tripmo is ready</span>
      <Button
        variant="primary"
        size="sm"
        disabled={loading}
        onClick={() => {
          setLoading(true);
          reloadToNewVersion();
        }}
      >
        {loading ? "Reloading…" : "Reload"}
      </Button>
    </div>
  );
}
